export const CardAnnouncementIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" fill="none" viewBox="0 0 12 13">
      <path
        fill="#000"
        fillOpacity="0.56"
        d="M10.667.578H1.333C.6.578 0 1.178 0 1.911v9.334c0 .733.6 1.333 1.333 1.333h9.334c.733 0 1.333-.6 1.333-1.333V1.91c0-.733-.6-1.333-1.333-1.333zM7.333 9.911H2.667V8.578h4.666v1.333zm2-2.666H2.667V5.91h6.666v1.334zm0-2.667H2.667V3.245h6.666v1.333z"
      ></path>
    </svg>
  )
}
export const CardLikeIcon = ({ className }: any) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16">
      <path d="M.25 15.328h3v-9h-3v9zm16.5-8.25c0-.825-.675-1.5-1.5-1.5h-4.732l.712-3.427.022-.24c0-.308-.127-.593-.33-.795l-.795-.788-4.935 4.943c-.277.27-.442.645-.442 1.057v7.5c0 .825.675 1.5 1.5 1.5H13a1.49 1.49 0 001.38-.915l2.265-5.287c.067-.173.105-.353.105-.548v-1.5z"></path>
    </svg>
  )
}
export const CardCommentIcon = ({ className }: any) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16">
      <path d="M13.5.078h-12c-.825 0-1.5.675-1.5 1.5v13.5l3-3h10.5c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5z"></path>
    </svg>
  )
}
export const CardClickIcon = ({ className }: any) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16">
      <path d="M7.25.38v5.948h5.25c0-3.06-2.287-5.58-5.25-5.947zM.5 10.829c0 3.315 2.685 6 6 6s6-2.685 6-6v-3H.5v3zM5.75.381A5.991 5.991 0 00.5 6.328h5.25V.381z"></path>
    </svg>
  )
}
export const CardShareIcon = ({ className }: any) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16">
      <path d="M12 10.638c-.57 0-1.08.225-1.47.578L5.183 8.103c.037-.172.067-.345.067-.525 0-.18-.03-.352-.067-.525l5.287-3.082a2.24 2.24 0 001.53.607 2.247 2.247 0 002.25-2.25A2.247 2.247 0 0012 .078a2.247 2.247 0 00-2.25 2.25c0 .18.03.353.068.525L4.53 5.936A2.24 2.24 0 003 5.328a2.247 2.247 0 00-2.25 2.25A2.247 2.247 0 003 9.828a2.24 2.24 0 001.53-.607l5.34 3.12c-.037.157-.06.322-.06.487 0 1.208.982 2.19 2.19 2.19 1.207 0 2.19-.982 2.19-2.19 0-1.207-.982-2.19-2.19-2.19z"></path>
    </svg>
  )
}
export const CardUserIcon = ({ className }: any) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16">
      <path d="M7.5.078c-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5zm0 2.25a2.247 2.247 0 012.25 2.25 2.247 2.247 0 01-2.25 2.25 2.247 2.247 0 01-2.25-2.25 2.247 2.247 0 012.25-2.25zm0 10.65A5.4 5.4 0 013 10.563c.022-1.492 3-2.31 4.5-2.31 1.492 0 4.477.818 4.5 2.31a5.4 5.4 0 01-4.5 2.415z"></path>
    </svg>
  )
}

export const ErrorIcon = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2ZM0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM11 6C11.5523 6 12 6.44772 12 7V12C12 12.5523 11.5523 13 11 13C10.4477 13 10 12.5523 10 12V7C10 6.44772 10.4477 6 11 6ZM11 14C11.5523 14 12 14.4477 12 15V15.01C12 15.5623 11.5523 16.01 11 16.01C10.4477 16.01 10 15.5623 10 15.01V15C10 14.4477 10.4477 14 11 14Z"
        fill="#D32F2F"
      />
    </svg>
  )
}

export const WarningIcon = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.401 2.49897C11.0159 1.83368 10.0553 1.83368 9.67016 2.49896L2.13906 15.5072C1.75309 16.1739 2.23416 17.0083 3.00448 17.0083H18.0667C18.837 17.0083 19.3181 16.1739 18.9321 15.5072L11.401 2.49897ZM7.93931 1.49689C9.09481 -0.498969 11.9764 -0.498958 13.1319 1.49689L20.663 14.5052C21.8209 16.5052 20.3777 19.0083 18.0667 19.0083H3.00448C0.693483 19.0083 -0.749683 16.5051 0.408208 14.5052L7.93931 1.49689ZM10.53 6.00829C11.0822 6.00518 11.5325 6.45038 11.5356 7.00265L11.558 10.9963C11.5611 11.5486 11.1159 11.9988 10.5636 12.0019C10.0114 12.005 9.56114 11.5598 9.55804 11.0076L9.53561 7.01389C9.5325 6.46161 9.9777 6.01139 10.53 6.00829ZM10.5356 12.9983C11.0879 12.9983 11.5356 13.446 11.5356 13.9983V14.0083C11.5356 14.5606 11.0879 15.0083 10.5356 15.0083C9.9833 15.0083 9.53559 14.5606 9.53559 14.0083V13.9983C9.53559 13.446 9.9833 12.9983 10.5356 12.9983Z"
        fill="#EF6C00"
      />
    </svg>
  )
}

export const InfoIcon = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2ZM0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM11 5.99977C11.5523 5.99977 12 6.44748 12 6.99977V7.00977C12 7.56205 11.5523 8.00977 11 8.00977C10.4477 8.00977 10 7.56205 10 7.00977V6.99977C10 6.44748 10.4477 5.99977 11 5.99977ZM11 9.00977C11.5523 9.00977 12 9.45748 12 10.0098V15.0098C12 15.5621 11.5523 16.0098 11 16.0098C10.4477 16.0098 10 15.5621 10 15.0098V10.0098C10 9.45748 10.4477 9.00977 11 9.00977Z"
        fill="#0288D1"
      />
    </svg>
  )
}
